<template>
	<div class="hello">
		<div class="logo">
			<img src="../assets/LogoLogo.png" />
		</div>
		<div class="logo_option">
			<div class="option" @click="personal">
				<div class="logo_option_img">
					<img class="option_img_one" src="../assets/Landpersonal.png" />
				</div>
				<div class="logo_option_content">
					<div class="reservation_mode">个人预约</div>
					<div class="logo_time">上午场（9:00-12:30）<br>下午场（12:30-16:30）</div>
				</div>
			</div>
			<div class="option option_ts" @click="land">
				<div class="logo_option_img">
					<img class="option_img_two" src="../assets/group.png" />
				</div>
				<div class="logo_option_content">
					<div class="reservation_mode">团体预约</div>
					<div class="logo_time">上午场（9:00-12:30）<br>下午场（12:30-16:30）</div>
				</div>
			</div>
			<div class="option option_ts" @click="travel">
				<div class="logo_option_img">
					<img class="option_img_two" src="../assets/group.png" />
				</div>
				<div class="logo_option_content">
					<div class="reservation_mode">旅行社预约</div>
					<div class="logo_time">上午场（9:00-12:30）<br>下午场（12:30-16:30）</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'logo',
		data() {
			return {
				msg: 'Welcome to Your Vue.js App',
				taid: "",
				bpp: false,
				baseUrl: "",
				baseUrlOne: ""
			}
		},
		methods: {
			personal() {
				var that = this;
				that.yin = true;
				sessionStorage.setItem('appointment_type', 'ticket')
				wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
				wclient.ajax({
					type: "POST",
					url: that.baseUrl + "/tickets/tickets/ajax?ugi=loginUgi&action=loginInfo",
					dataType: "json",
					async: true,
					data: {

					},
					success: function(data) {
						if(data.code == 'A00006') {
							if(data.loginType == 'personalLogin') {
								that.$http({
									method: "get",
									url: that.baseUrl + '/tickets/tickets/ajax?ugi=ticketactivity&action=getActivityList&moduleid=TICKETS&categoryid=2d74de112b1944ef863539496d4efe96&sponsorid=a0df565fe509435eba413105fc9a006c',
									headers: {
										'Content-Type': 'application/x-www-form-urlencoded'
									}
								}).then(res => {
									if(res.data.code == 'A00006') {
										that.taid = res.data.activitylist[0].taid;
										sessionStorage.setItem("taid", that.taid);
										sessionStorage.setItem("name", data.personalAccount.name);
										sessionStorage.setItem("RegistrantName", data.personalAccount.name);
										sessionStorage.setItem("RegistrantIdNumber", data.personalAccount.idnumber);
										sessionStorage.setItem("orderType", "0");
										that.$router.push({
											name: 'Personal'
										})
									}

								}).catch(res => {
									console.log('发送Ajax请求,请求失败', res);
								});
							} else if(data.loginType == 'teamLogin') {

								that.$http({
									method: "get",
									url: that.baseUrl + '/tickets/tickets/ajax?ugi=ticketactivity&action=getActivityList&moduleid=TICKETS&categoryid=2d74de112b1944ef863539496d4efe96&sponsorid=a0df565fe509435eba413105fc9a006c',
									headers: {
										'Content-Type': 'application/x-www-form-urlencoded'
									}
								}).then(res => {
									if(res.data.code == 'A00006') {
										that.taid = res.data.activitylist[0].taid;
										sessionStorage.setItem("taid", that.taid);
										sessionStorage.setItem("orderType", "0");
										that.$router.push({
											name: 'PersonalLand'
										});
									}

								}).catch(res => {
									console.log('发送Ajax请求,请求失败', res);
								});

							}
						} else if(data.code == 'A00004') {
							that.$http({
								method: "get",
								url: that.baseUrl + '/tickets/tickets/ajax?ugi=ticketactivity&action=getActivityList&moduleid=TICKETS&categoryid=2d74de112b1944ef863539496d4efe96&sponsorid=a0df565fe509435eba413105fc9a006c',
								headers: {
									'Content-Type': 'application/x-www-form-urlencoded'
								}
							}).then(res => {
								if(res.data.code == 'A00006') {
									that.taid = res.data.activitylist[0].taid;
									sessionStorage.setItem("taid", that.taid);
									sessionStorage.setItem("orderType", "0");
									that.$router.push({
										name: 'PersonalLand'
									})
								}

							}).catch(res => {
								console.log('发送Ajax请求,请求失败', res);
							});
						}
						wclient.view.hideLoading();

					}
				});

			},
			land() {
				var that = this;
				that.yin = true;
				sessionStorage.setItem('appointment_type', 'ticket')
				wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
				wclient.ajax({
					type: "POST",
					url: that.baseUrl + "/tickets/tickets/ajax?ugi=loginUgi&action=loginInfo",
					dataType: "json",
					async: true,
					data: {

					},
					success: function(data) {
						if(data.code == 'A00006') {
							if(data.loginType == 'personalLogin') {
								that.$http({
									method: "get",
									url: that.baseUrl + '/tickets/tickets/ajax?ugi=ticketactivity&action=getActivityList&moduleid=TICKETS&categoryid=2d74de112b1944ef863539496d4efe96&sponsorid=a0df565fe509435eba413105fc9a006c',
									headers: {
										'Content-Type': 'application/x-www-form-urlencoded'
									}
								}).then(res => {
									if(res.data.code == 'A00006') {
										that.taid = res.data.activitylist[0].taid;
										sessionStorage.setItem("taid", that.taid);
										sessionStorage.setItem("orderType", "1");
										that.$router.push({
											name: 'Land'
										})
									}

								}).catch(res => {
									console.log('发送Ajax请求,请求失败', res);
								});
							} else if(data.loginType == 'teamLogin') {
								if(data.teamAccount.teamtype != '5') {
									that.$http({
										method: "get",
										url: that.baseUrl + '/tickets/tickets/ajax?ugi=ticketactivity&action=getActivityList&moduleid=TICKETS&categoryid=2d74de112b1944ef863539496d4efe96&sponsorid=a0df565fe509435eba413105fc9a006c',
										headers: {
											'Content-Type': 'application/x-www-form-urlencoded'
										}
									}).then(res => {
										if(res.data.code == 'A00006') {
											that.taid = res.data.activitylist[0].taid;
											sessionStorage.setItem("taid", that.taid);
											sessionStorage.setItem("orderType", "1");
											sessionStorage.setItem("name", data.teamAccount.teamname);
											sessionStorage.setItem("RegistrantName", data.teamAccount.realname);
											sessionStorage.setItem("RegistrantIdNumber", data.teamAccount.idnumber);
											sessionStorage.setItem("RegistrantPhone", data.teamAccount.phone);
											sessionStorage.setItem("RegistrantTeamname", data.teamAccount.teamname);
											that.$router.push({
												name: 'TeamReservation'
											});
										}

									}).catch(res => {
										console.log('发送Ajax请求,请求失败', res);
									});
								}else{
									that.$router.push({
										name: 'Land'
									})
								}
							}
						} else if(data.code == 'A00004') {
							that.$http({
								method: "get",
								url: that.baseUrl + '/tickets/tickets/ajax?ugi=ticketactivity&action=getActivityList&moduleid=TICKETS&categoryid=2d74de112b1944ef863539496d4efe96&sponsorid=a0df565fe509435eba413105fc9a006c',
								headers: {
									'Content-Type': 'application/x-www-form-urlencoded'
								}
							}).then(res => {
								if(res.data.code == 'A00006') {
									that.taid = res.data.activitylist[0].taid;
									sessionStorage.setItem("taid", that.taid);
									sessionStorage.setItem("orderType", "1");
									that.$router.push({
										name: 'Land'
									})
								}

							}).catch(res => {
								console.log('发送Ajax请求,请求失败', res);
							});
						}
						wclient.view.hideLoading();

					}
				});
			},
			travel() {
				var that = this;
				that.yin = true;
				sessionStorage.setItem('appointment_type', 'ticket')
				wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
				wclient.ajax({
					type: "POST",
					url: that.baseUrl + "/tickets/tickets/ajax?ugi=loginUgi&action=loginInfo",
					dataType: "json",
					async: true,
					data: {

					},
					success: function(data) {
						if(data.code == 'A00006') {
							if(data.loginType == 'personalLogin') {
								that.$http({
									method: "get",
									url: that.baseUrl + '/tickets/tickets/ajax?ugi=ticketactivity&action=getActivityList&moduleid=TICKETS&categoryid=2d74de112b1944ef863539496d4efe96&sponsorid=a0df565fe509435eba413105fc9a006c',
									headers: {
										'Content-Type': 'application/x-www-form-urlencoded'
									}
								}).then(res => {
									if(res.data.code == 'A00006') {
										that.taid = res.data.activitylist[0].taid;
										sessionStorage.setItem("taid", that.taid);
										sessionStorage.setItem("orderType", "1");
										that.$router.push({
											name: 'Travel'
										})
									}

								}).catch(res => {
									console.log('发送Ajax请求,请求失败', res);
								});
							} else if(data.loginType == 'teamLogin') {
								if(data.teamAccount.teamtype == '5') {
									that.$http({
										method: "get",
										url: that.baseUrl + '/tickets/tickets/ajax?ugi=ticketactivity&action=getActivityList&moduleid=TICKETS&categoryid=2d74de112b1944ef863539496d4efe96&sponsorid=a0df565fe509435eba413105fc9a006c',
										headers: {
											'Content-Type': 'application/x-www-form-urlencoded'
										}
									}).then(res => {
										if(res.data.code == 'A00006') {
											that.taid = res.data.activitylist[0].taid;
											sessionStorage.setItem("taid", that.taid);
											sessionStorage.setItem("orderType", "1");
											sessionStorage.setItem("name", data.teamAccount.teamname);
											sessionStorage.setItem("RegistrantName", data.teamAccount.realname);
											sessionStorage.setItem("RegistrantIdNumber", data.teamAccount.idnumber);
											sessionStorage.setItem("RegistrantPhone", data.teamAccount.phone);
											sessionStorage.setItem("RegistrantTeamname", data.teamAccount.teamname);
											that.$router.push({
												name: 'Personal'
											});
										}

									}).catch(res => {
										console.log('发送Ajax请求,请求失败', res);
									});
								}else{
									that.$router.push({
										name: 'Travel'
									})
								}
							}
						} else if(data.code == 'A00004') {
							that.$http({
								method: "get",
								url: that.baseUrl + '/tickets/tickets/ajax?ugi=ticketactivity&action=getActivityList&moduleid=TICKETS&categoryid=2d74de112b1944ef863539496d4efe96&sponsorid=a0df565fe509435eba413105fc9a006c',
								headers: {
									'Content-Type': 'application/x-www-form-urlencoded'
								}
							}).then(res => {
								if(res.data.code == 'A00006') {
									that.taid = res.data.activitylist[0].taid;
									sessionStorage.setItem("taid", that.taid);
									sessionStorage.setItem("orderType", "1");
									that.$router.push({
										name: 'Travel'
									})
								}

							}).catch(res => {
								console.log('发送Ajax请求,请求失败', res);
							});
						}
						wclient.view.hideLoading();

					}
				});
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
			wclient.baseURL = '//xs.weapi.org';
				var baseUrl = "http://xs.weapi.org";
				var baseUrlOne = "http://tickets.xs.weapi.org";
			} else if(publicUrl == "m.xs.weapi.org") {
			wclient.baseURL = '//xs.weapi.org';
				var baseUrl = "http://xs.weapi.org";
				var baseUrlOne = "http://tickets.xs.weapi.org";
				
			} else {
				wclient.baseURL = '//www.xiangshan1949.cn';
				var baseUrl = "https://www.xiangshan1949.cn";
				var baseUrlOne = "https://www.xiangshan1949.cn";
			}
			that.baseUrl = baseUrl;
			that.baseUrlOne = baseUrlOne;
			console.log(localStorage.getItem('access_token'))
			if(localStorage.getItem('access_token') == null) {
				console.log(localStorage.getItem('access_token'))
				wclient.crossdomain = true;
				wclient.connect('', function(data) {
					if(data.code == 'A00006') {
						localStorage.setItem('access_token', data.access_token)
						if(sessionStorage.getItem('token_type') == 'seek') {
							sessionStorage.removeItem('token_type')
							that.$router.push({
								name: 'Seek'
							})
						} else if(sessionStorage.getItem('token_type') == 'center') {
							sessionStorage.removeItem('token_type')
							that.$router.push({
								name: 'ToCenter'
							})
						} else if(sessionStorage.getItem('token_type') == 'Complaint') {
							sessionStorage.removeItem('token_type')
							that.$router.push({
								name: 'Complaint'
							})
						} else if(sessionStorage.getItem('token_type') == 'activity') {
							sessionStorage.removeItem('token_type')
							that.$router.push({
								name: 'ActivityRegistration'
							})
						}
					}
				})
			} else {
				$.ajax({
					type: "GET",
					url: that.baseUrlOne + "/tickets/tickets/ajax?ugi=loginUgi&action=logininfo",
					dataType: "json",
					async: true,
					data: {
						access_token: localStorage.getItem('access_token')
					},
					success: function(res) {
						if(res.code == 'A00006') {
							if(sessionStorage.getItem('token_type') == 'seek') {
								sessionStorage.removeItem('token_type')
								that.$router.push({
									name: 'Seek'
								})
							} else if(sessionStorage.getItem('token_type') == 'center') {
								sessionStorage.removeItem('token_type')
								that.$router.push({
									name: 'ToCenter'
								})
							} else if(sessionStorage.getItem('token_type') == 'Complaint') {
								sessionStorage.removeItem('token_type')
								that.$router.push({
									name: 'Complaint'
								})
							} else if(sessionStorage.getItem('token_type') == 'activity') {
								sessionStorage.removeItem('token_type')
								that.$router.push({
									name: 'ActivityRegistration'
								})
							} else if(sessionStorage.getItem('token_type') == 'Lease') {
								sessionStorage.removeItem('token_type')
								that.$router.push({
									name: 'Lease'
								})
							}
						} else {
							wclient.crossdomain = true;
							wclient.connect('', function(data) {
								if(data.code == 'A00006') {
									localStorage.setItem('access_token', data.access_token)
									if(sessionStorage.getItem('token_type') == 'seek') {
										sessionStorage.removeItem('token_type')
										that.$router.push({
											name: 'Seek'
										})
									} else if(sessionStorage.getItem('token_type') == 'center') {
										sessionStorage.removeItem('token_type')
										that.$router.push({
											name: 'ToCenter'
										})
									} else if(sessionStorage.getItem('token_type') == 'Complaint') {
										sessionStorage.removeItem('token_type')
										that.$router.push({
											name: 'Complaint'
										})
									} else if(sessionStorage.getItem('token_type') == 'activity') {
										sessionStorage.removeItem('token_type')
										that.$router.push({
											name: 'ActivityRegistration'
										})
									}
								}
							})
						}
					}
				});
			}
		}
	}
</script>

<style scoped>
	.page-container {
		display: none;
	}
	
	.hello {
		width: 100%;
		height: 100vh;
		background: url("../assets/LogoBackground.png") center center no-repeat;
		background-size: cover;
	}
	
	.logo {
		width: 65%;
		margin: 0 auto;
		padding-top: 20%;
	}
	
	.logo img {
		width: 100%;
	}
	
	.option {
		width: 68%;
		height: 50px;
		background: white;
		display: flex;
		margin: 0 auto;
		padding: 25px 8%;
		align-items: center;
		border-radius: 10px;
	}
	
	.option_img_one {
		width: 50px;
	}
	
	.option_img_two {
		width: 50px;
		display: block;
	}
	
	.reservation_mode {
		font-size: 17px;
		font-family: PingFangSC-Medium;
		font-weight: 600;
		color: rgba(45, 45, 45, 1);
		line-height: 30px;
	}
	
	.logo_time {
		width: 100%;
		font-size: 12px;
		font-family: PingFangSC-Regular;
		font-weight: 400;
		color: rgba(121, 121, 121, 1);
		line-height: 18px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	
	.option_ts {
		margin-top: 15px;
	}
	
	.logo_option {
		margin-top: 10%;
	}
	
	.logo_option_img {
		margin-right: 8%;
		width: 14%;
		display: flex;
		justify-content: center;
	}
	
	.logo_option_content {
		width: 81%;
	}
</style>


// WEBPACK FOOTER //
// src/components/logo.vue